export default __webpack_public_path__ + "static/media/popup-mobile.21c9d8a2.svg";